module.exports = {
  CloseProject: 'Đóng dự án',
  RebuildProject: 'Mở lại dự án',
  ProjectNo: 'Mã dự án',
  CustomerName: 'Tên khách hàng',
  ProjectStatus: 'Trạng thái dự án',
  ProjectName: 'Tên dự án',
  ProjectCycle: 'Chu kỳ dự án',
  ProjectManager: 'Quản lý dự án',
  ProjectDepartment: 'Phòng ban dự án',
  ProjectOffice: 'Công ty dự án',
  ExpectIncome: 'Doanh thu dự kiến',
  ExpectCost: 'Chi phí dự kiến',
  ExpectExpense: 'Phí dự kiến',
  RealIncome: 'Doanh thu thực tế',
  RealCost: 'Chi phí thực tế',
  RealExpense: 'Phí thực tế',
  SettleCurrency: 'Loại tiền tệ hạch toán',
  Remarks: 'Mô tả dự án',
  ExpectTotalCost: 'Tổng chi phí dự kiến',
  RealTotalCost: 'Tổng chi phí thực tế',
  ExpectProfitTate: 'Tỷ suất lợi nhuận dự kiến',
  RealProfitTate: 'Tỷ suất lợi nhuận thực tế',
  ReceiveStatus: 'Trạng thái thu tiền',
  PayStatus: 'Trạng thái thanh toán',
  StartDate: 'Ngày bắt đầu',
  EndtDate: 'Ngày kết thúc'
}
